/**
 * <xenon-indirim-popup> — e-posta + telefon karşılığında indirim kodu.
 *
 * İKİ SAYFA YÜKLEMESİ, TEK AKIŞ. Form Shopify'ın customer formu ve gerçekten
 * gönderilir (hCaptcha token'ı ancak böyle eklenir, fetch 400 döner). Gönderim
 * anında sessionStorage'a bir bayrak yazılır; Shopify sayfayı geri yüklediğinde
 * bayrak + Liquid'in bıraktığı dönüş işareti birlikte okunur ve popup kod
 * adımıyla açılır.
 *
 * Gösterim kaydı popup AÇILIRKEN yazılır (temanın subscription-popup'ı da
 * öyle yapar): kapatmadan sayfadan çıkan, geri tuşuna basan ziyaretçi her
 * sayfada yeniden karşılaşmasın. Açılan için `dismiss-days` gün, formu dolduran
 * için bir yıl.
 *
 * KENAR SEKMESİ. Kapatan ziyaretçi bu süre boyunca popup'ı sol kenardaki
 * sekmeden kendisi açabilir. Sekme yalnızca otomatik açılış beklenirken, popup
 * açıkken, gönderim sürerken ve form doldurulduktan sonra gizlidir.
 */
customElements.whenDefined('drawer-component').then(() => {
  if (customElements.get('xenon-indirim-popup')) return;

  const STORAGE_KEY = 'xenon-indirim-popup';
  const PENDING_KEY = 'xenon-indirim-popup:pending';
  const VIEWS_KEY = 'xenon-indirim-popup:views';
  /* Bayrak bundan eskiyse gönderim yarıda kalmıştır (captcha kapatıldı,
     sekme başka yere gitti); dönüş sayılmaz. Section'daki satır içi betik
     aynı süreyi (900000 ms) kullanır. */
  const PENDING_MAX_AGE_MS = 15 * 60 * 1000;
  const DONE_DAYS = 365;
  /* Sepet çekmecesi, hızlı bakış gibi başka bir pencere açıkken araya girme;
     kapanınca bu aralıkla yeniden dene. */
  const BUSY_RETRY_MS = 3000;
  /* Stil dosyası gecikmeli yüklenir (media=print); en çok bu kadar beklenir. */
  const STYLES_MAX_WAIT_MS = 3000;
  const CONSENT_TAG = 'ileti-izni-eposta-sms';
  const MOBILE_QUERY = '(max-width: 767.98px)';
  /* Editörde "Telefon hata mesaji" boş bırakılırsa. */
  const PHONE_ERROR = 'Geçerli bir cep telefonu numarası gir (5XX XXX XX XX).';

  /**
   * "0532 123 45 67", "+90 532-123-4567", "+90 0532…", "0090 532…",
   * "5321234567" → "+905321234567". Türkiye cep numarası değilse null.
   */
  const normalizePhone = (value) => {
    let digits = String(value || '').replace(/\D/g, '');
    if (digits.startsWith('00')) digits = digits.slice(2);
    if (digits.length >= 12 && digits.startsWith('90')) digits = digits.slice(2);
    if (digits.startsWith('0')) digits = digits.slice(1);
    return /^5\d{9}$/.test(digits) ? `+90${digits}` : null;
  };

  /* FoxTheme.utils localStorage kullanır ve yoksa sessizce hiçbir şey yapmaz;
     o durumda çereze düşeriz. İkisi de yoksa kapatmayı hatırlayamayız ve popup
     her sayfada açılırdı — writable() false ise hiç açmayız. */
  const hasLocalStorage = () => Boolean(window.FoxTheme?.config?.hasLocalStorage);
  const storage = {
    get() {
      if (hasLocalStorage()) return window.FoxTheme.utils.getStorage(STORAGE_KEY);
      const match = document.cookie.match(new RegExp(`(?:^|; )${STORAGE_KEY}=([^;]*)`));
      return match ? { state: decodeURIComponent(match[1]) } : null;
    },
    set(state, days) {
      if (hasLocalStorage()) {
        window.FoxTheme.utils.setStorage(STORAGE_KEY, { state }, days);
        return;
      }
      document.cookie = `${STORAGE_KEY}=${encodeURIComponent(state)}; max-age=${Math.round(days * 86400)}; path=/; SameSite=Lax`;
    },
    writable() {
      return hasLocalStorage() || navigator.cookieEnabled;
    },
  };

  /* Gönderim bayrağı. Telefon da saklanır: e-posta hatasıyla dönülürse alan
     yeniden doldurulur. */
  const pending = {
    read() {
      try {
        const data = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null');
        if (data && Date.now() - data.at <= PENDING_MAX_AGE_MS) return data;
        sessionStorage.removeItem(PENDING_KEY);
      } catch (e) {}
      return null;
    },
    write(phone) {
      try {
        sessionStorage.setItem(PENDING_KEY, JSON.stringify({ at: Date.now(), phone }));
      } catch (e) {}
    },
    clear() {
      try {
        sessionStorage.removeItem(PENDING_KEY);
      } catch (e) {}
    },
  };

  /* Oturumun kaçıncı sayfası. Mobilde aramadan gelinen ilk sayfada tam ekran
     pencere açmamak için (Google "intrusive interstitial"). sessionStorage
     yoksa 1 döner: emin olamıyorsak mobilde açmayız. */
  const countPageView = () => {
    try {
      const views = (Number(sessionStorage.getItem(VIEWS_KEY)) || 0) + 1;
      sessionStorage.setItem(VIEWS_KEY, String(views));
      return views;
    } catch (e) {
      return 1;
    }
  };

  customElements.define(
    'xenon-indirim-popup',
    class XenonIndirimPopup extends customElements.get('drawer-component') {
      get requiresBodyAppended() {
        return false;
      }

      /* Tema varsayılanı ilk düğmeyi (kapat) odaklar; kendiliğinden açılan bir
         pencerede bu, X'in çevresinde odak halkası bırakıyor. Kabın kendisi
         (tabindex=-1, role=dialog) odaklanır: ekran okuyucu başlığı okur ve
         trapFocus kabı tanıdığı için Shift+Tab pencereden kaçmaz. */
      get focusElement() {
        return this;
      }

      connectedCallback() {
        super.connectedCallback();

        this.form = this.querySelector('form');
        this.phoneInput = this.querySelector('[data-xpop-phone]');
        this.consentInput = this.querySelector('[data-xpop-consent]');
        this.tagsInput = this.querySelector('[data-xpop-tags]');
        this.submitButton = this.querySelector('[data-xpop-submit]');
        this.codeElement = this.querySelector('[data-xpop-code]');
        this.teaser = document.getElementById(`${this.id}-teaser`);
        /* Sekme serbest bırakılana kadar gizli kalır (bkz. syncTeaser). */
        this.teaserHeld = true;

        this.bindForm();
        this.bindTeaser();

        if (window.Shopify?.designMode) {
          this.showStep(this.dataset.editorStep === 'done' ? 'done' : 'form');
          this.releaseTeaser();
          return;
        }

        const pageView = countPageView();
        const submission = pending.read();
        if (submission) {
          if (this.querySelector('[data-xpop-result]')?.dataset.return === 'true') {
            pending.clear();
            this.cleanUrl();
            this.handleReturn(submission);
          }
          /* Dönüş değilse gönderim sürüyor (captcha ara sayfası, yarıda kalmış
             doğrulama): bayrağı silme, formu da yeniden açma. Bayrak
             PENDING_MAX_AGE_MS sonra kendiliğinden düşer. */
          return;
        }

        this.scheduleOpen(pageView);
      }

      bindTeaser() {
        if (!this.teaser) return;
        const { signal } = this.abortController;
        this.teaser.addEventListener('click', () => this.openFromTeaser(), { signal });
        /* ModalComponent her open/kapanış değişiminde 'toggle' yayar. */
        this.addEventListener('toggle', () => this.syncTeaser(), { signal });
      }

      syncTeaser() {
        if (!this.teaser) return;
        this.teaser.hidden = this.teaserHeld || this.opening || this.open || storage.get()?.state === 'done';
      }

      releaseTeaser() {
        this.teaserHeld = false;
        this.syncTeaser();
      }

      openFromTeaser() {
        this.showStep('form');
        this.markSeen();
        this.releaseTeaser();
        /* Kapanınca odak sekmeye döner (ModalComponent activeElement). */
        this.reveal(this.teaser);
      }

      bindForm() {
        if (!this.form || !this.phoneInput || !this.tagsInput) return;
        const { signal } = this.abortController;
        /* Taban liste bir kez okunur: gizli input'ta .value atamak value
           özniteliğini (defaultValue) da değiştirir, ikinci çağrı üst üste
           eklerdi. */
        const baseTags = this.tagsInput.value;
        const phoneError = this.dataset.phoneError || PHONE_ERROR;

        this.phoneInput.addEventListener(
          'input',
          () => this.phoneInput.setCustomValidity(normalizePhone(this.phoneInput.value) ? '' : phoneError),
          { signal }
        );

        /* Hem tıklamada hem submit'te: Shopify'ın captcha betiği submit'i
           kendi dinleyicisinde yakalayıp formu sonra form.submit() ile
           gönderiyor, o yüzden submit olayına tek başına güvenmiyoruz. Enter
           ile gönderim de varsayılan düğmeye tıklama olayı üretir. İki kez
           çalışması zararsız: etiket listesi her seferinde baseTags'ten kurulur. */
        const prepare = () => {
          const phone = normalizePhone(this.phoneInput.value);
          this.phoneInput.setCustomValidity(phone ? '' : phoneError);
          if (!phone || !this.form.checkValidity()) return;

          this.tagsInput.value = [baseTags, CONSENT_TAG, `tel:${phone}`].join(',');
          pending.write(phone);
          /* Sayfa gidince zaten kaybolur; captcha penceresi kapatılırsa düğme
             takılı kalmasın. */
          this.submitButton?.classList.add('btn--loading');
          setTimeout(() => this.submitButton?.classList.remove('btn--loading'), 8000);
        };
        this.submitButton?.addEventListener('click', prepare, { signal });
        this.form.addEventListener('submit', prepare, { signal });
      }

      /**
       * Popup'ın gönderiminden dönülen sayfa. E-posta hatası varsa form,
       * yazılan telefon ve işaretli izinle yeniden açılır. Yoksa (başarı ya da
       * kayıtlı e-posta) kod adımı.
       */
      handleReturn(submission) {
        if (this.querySelector('[data-xpop-result]')?.dataset.emailError === 'true') {
          if (submission.phone && this.phoneInput) this.phoneInput.value = submission.phone;
          if (this.consentInput) this.consentInput.checked = true;
          this.showStep('form');
          this.markSeen();
          this.releaseTeaser();
          this.reveal();
          return;
        }

        storage.set('done', DONE_DAYS);
        this.showStep('done');
        this.applyDiscount();
        this.reveal();
      }

      /* Shopify'ın /discount/KOD adresi kodu çereze yazar; ödeme adımında
         kendiliğinden uygulanır. Sepet boş olsa da çalışır. Hafif bir yanıt
         için /cart.js'e yönlendiriyoruz. Başarısız olursa kod zaten ekranda. */
      applyDiscount() {
        const code = this.codeElement?.dataset.code;
        if (!code) return;
        const root = window.Shopify?.routes?.root || '/';
        fetch(`${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(`${root}cart.js`)}`, {
          credentials: 'same-origin',
        }).catch(() => {});
      }

      /* Dönüş URL'sindeki customer_posted / form_type / contact[...] izlerini
         ve form çapasını sil: paylaşılan ya da yenilenen sayfada akış yeniden
         tetiklenmesin, form alanları adres çubuğunda kalmasın. */
      cleanUrl() {
        const url = new URL(window.location.href);
        let changed = false;
        [...url.searchParams.keys()].forEach((key) => {
          /* "contact" tek başına: önizleme yönlendirmesi contact[email]=…
             parametresini contact={"email" => …} olarak yeniden yazıyor. */
          if (['customer_posted', 'form_type', 'utf8', 'contact'].includes(key) || key.startsWith('contact[')) {
            url.searchParams.delete(key);
            changed = true;
          }
        });
        if (url.hash && this.form && url.hash === `#${this.form.id}`) {
          url.hash = '';
          changed = true;
        }
        if (changed) window.history.replaceState(window.history.state, '', url.toString());
      }

      scheduleOpen(pageView) {
        /* Otomatik açılmayacaksa (yakında açılıp kapatılmış, kayıt tutulamıyor,
           mobilde ilk sayfa) ziyaretçi yalnızca sekmeyle açabilir. */
        if (storage.get() || !storage.writable()) {
          this.releaseTeaser();
          return;
        }
        if (
          pageView < 2 &&
          this.dataset.skipMobileLanding === 'true' &&
          window.matchMedia(MOBILE_QUERY).matches
        ) {
          this.releaseTeaser();
          return;
        }
        const delay = Math.max(0, Number(this.dataset.delay) || 0) * 1000;
        setTimeout(() => this.openWhenFree(), delay);
      }

      openWhenFree() {
        if (this.open) return;
        if (storage.get()) {
          this.releaseTeaser();
          return;
        }
        const body = document.body.classList;
        if (body.contains('modal-show') || body.contains('modal-showing')) {
          setTimeout(() => this.openWhenFree(), BUSY_RETRY_MS);
          return;
        }
        this.showStep('form');
        this.markSeen();
        this.releaseTeaser();
        this.reveal();
      }

      markSeen() {
        if (window.Shopify?.designMode) return;
        storage.set('seen', Math.max(1, Number(this.dataset.dismissDays) || 3));
      }

      /* Stil dosyası gecikmeli yükleniyor; dönüş sayfasında popup hemen
         açıldığı için stilsiz bir an görünmesin diye önce onu bekle. Satır içi
         onload media'yı 'all' yapar, yani 'print' hâlâ yüklenmedi demek. */
      async reveal(activeElement = null) {
        /* Beklerken sekme görünmesin; show() sonrası 'toggle' zaten gizler. */
        this.opening = true;
        this.syncTeaser();
        const link = document.getElementById('XenonIndirimPopupCss');
        if (link && link.media === 'print') {
          await new Promise((resolve) => {
            link.addEventListener('load', resolve, { once: true });
            link.addEventListener('error', resolve, { once: true });
            setTimeout(resolve, STYLES_MAX_WAIT_MS);
          });
        }
        this.show(activeElement);
        this.opening = false;
      }

      showStep(name) {
        this.querySelectorAll('[data-xpop-step]').forEach((step) => {
          const active = step.dataset.xpopStep === name;
          step.hidden = !active;
          /* trapFocus ilk/son odaklanabilir öğeyi görünürlüğe bakmadan seçer
             ama button:enabled'a bakar: gizli adımın düğmeleri kapalı olmazsa
             "son öğe" gizli bir düğme olur ve Tab pencereden kaçar. */
          step.querySelectorAll('button').forEach((button) => {
            button.disabled = !active;
          });
        });
        this.dataset.step = name;

        const title = this.querySelector(`[data-xpop-step="${name}"] [data-xpop-title]`);
        if (title) this.setAttribute('aria-labelledby', title.id);
      }
    }
  );
});
